// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__2vH4h","item":"Menu_item__1n4-Q","disabled":"Menu_disabled__GSIzY"};